import makeStyles from '@mui/styles/makeStyles';
import createStyles from '@mui/styles/createStyles';
import { ComplexStatusRoundingDirection } from 'src/constants/complexStatus';

export const useStyles = makeStyles(() => createStyles({
  '@keyframes fadeIn': {
    '0%': { opacity: 0 },
    '100%': { opacity: 1 },
  },
  complexStatusWrapperStable: {
    width: '128px',
    padding: '8px 20px',
    height: '32px',
    color: 'white',
    fontSize: '14px',
    lineHeight: '16px',
    display: 'flex',
    justifyContent: 'center',
    borderRadius: '180px',
    cursor: 'default',
  },
  complexStatusWrapperHovered: (props: any) => ({
    width: '64px',
    padding: '4px 8px',
    height: '20px',
    color: 'white',
    fontSize: '10px',
    lineHeight: '14px',
    display: 'flex',
    justifyContent: 'center',
    borderRadius: props.roundingDirection === ComplexStatusRoundingDirection.LEFT ? '0 180px 180px 0' : '180px 0 0 180px',
    transition: 'width .3s',
    '& .text': {
      animation: 'fadeIn .9s ease-out',
      color: props.textColor,
    },
  }),
  complexStatusWrapperDefault: (props: any) => ({
    width: '20px',
    height: '20px',
    borderRadius: props.roundingDirection === ComplexStatusRoundingDirection.LEFT ? '0 180px 180px 0' : '180px 0 0 180px',
  }),
}));
